/* StartEndComponent.js */

"use strict";
const Renderer = require("./StartEndRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class StartEndComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
}
module.exports = StartEndComponent;
